import { useEffect, useRef } from 'react';

/**
 * Recarga los datos de una página cuando llega una invalidación en tiempo real.
 * No remonta el componente: conserva filtros, paginación y edición en curso.
 */
export default function useInvalidate(domains, onInvalidate) {
  const cbRef = useRef(onInvalidate);
  cbRef.current = onInvalidate;
  const domainsRef = useRef(domains);
  domainsRef.current = domains;

  useEffect(() => {
    function handler(ev) {
      const wanted = domainsRef.current;
      const incoming = ev.detail?.domains || [];
      if (wanted?.length && !incoming.some((d) => wanted.includes(d))) return;
      cbRef.current?.();
    }
    window.addEventListener('oh:invalidate', handler);
    return () => window.removeEventListener('oh:invalidate', handler);
  }, []);
}
